<script>
export default {
    // eslint-disable-next-line vue/require-prop-type-constructor
    props: { id: "" },
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Welcome",
    data() {
        return {
            name: "",
        };
    },
    methods: {
        createActivity() {
            this.$router.push({ name: "Listing type" });
            // this.activeStep = 1;
            // this.$storage.setStorageSync('step', this.activeStep);
        },
    },
    mounted() {
        this.name = window.currentUserName;
        this.$storage.clearStorageSync();
        if (window.adminEdit !== undefined && window.adminEdit && this.id !== "") {
            // TODO: remove jquery
            // eslint-disable-next-line no-undef
            $.ajax({
                url: "/get-recovery-data",
                method: "POST",
                data: {
                    id: this.id,
                },
                dataType: "json",
            }).done((response) => {
                if (response.error) {
                    // Show the error to admin if any in recovery data flow
                    console.log("error");
                }

                if (response.data) {
                    const dataForLS = response.data;
                    // eslint-disable-next-line array-callback-return
                    Object.keys(dataForLS).map((el) => {
                        if (el === "weeklySessions") {
                            // eslint-disable-next-line array-callback-return
                            dataForLS[el].map((sessionsPerLocation) => {
                                // eslint-disable-next-line array-callback-return
                                Object.keys(sessionsPerLocation).map((venueName) => {
                                    this.$storage.setStorageSync(
                                        `weeklySessions-${venueName}`,
                                        sessionsPerLocation[venueName],
                                    );
                                });
                            });
                        } else if (el === "dailySessions") {
                            // eslint-disable-next-line array-callback-return
                            dataForLS[el].map((sessionsPerLocation) => {
                                // eslint-disable-next-line array-callback-return
                                Object.keys(sessionsPerLocation).map((venueName) => {
                                    this.$storage.setStorageSync(
                                        `dailySessions-${venueName}`,
                                        sessionsPerLocation[venueName],
                                    );
                                });
                            });
                        } else {
                            this.$storage.setStorageSync(el, dataForLS[el]);
                        }
                    });

                    this.$storage.setStorageSync("adminEdit", true);
                }

                if (response.data_errors) {
                    // eslint-disable-next-line array-callback-return
                    Object.keys(response.data_errors).map((error) => {
                        this.$storage.setStorageSync(`rec-${error}`, response.data_errors[error]);
                    });
                }
            });
        }
    },
};
</script>

<template>
    <div class="welcome mx-auto mt-3">
        <h2>Welcome, {{ name }}</h2>

        <div class="mt-3 mb-4 text-activate-info">
            Get started with Loopla by creating your first listing
        </div>

        <div @click="createActivity"
             class="choose-step-block mt-3 font-weight-bold create-activity"
             data-test="link-create-activity">
            Create an activity or event
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66699 2.83301L9.33366 7.49967L4.66699 12.1663" stroke="#260045" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        </div>
    </div>
</template>

<style scoped>
@media only screen and (max-width: 768px) {
    .welcome {
        padding: 0 20px;
    }
}
</style>
